import { useMemo } from 'react';
import { JiraIssueData } from '../../../../api/endpoints/jira';
import { RecordSetManager } from '../../../../concepts/objects/RecordSetManager';
import { useResolve } from '../../../Container';

export const useJiraIssueRecord = (jiraIssueId: string) => {
    const rsm = useResolve(RecordSetManager);
    const recordSet = useMemo(() => rsm.resolve<JiraIssueData>('JiraIssues'), [rsm]);
    return recordSet.getForFuture(jiraIssueId);
};
